export default __webpack_public_path__ + "static/media/left.4de470cd.svg";